module.exports = __webpack_public_path__ + "img/bz23.13b622a4.svg";